module.exports = __webpack_public_path__ + "static/media/footer_logo.c7add7a8.svg";